import { CHAINS } from "../constants/chains";

const TOKEN_LABEL_MAP = {
  [CHAINS.CRONOS.NAME]: {},
  [CHAINS.ZKSYNC.NAME]: {
    USDC: "USDC.e",
    "USDC.native": "USDC",
  },
};

export const getTokenLabel = (symbol, chainName) => {
  if (TOKEN_LABEL_MAP[chainName]?.[symbol]) {
    return TOKEN_LABEL_MAP[chainName][symbol];
  } else {
    return symbol;
  }
};
